<template>
  <div :class="{ 'd-flex flex-row justify-space-between': row }">
    <span class="subtitle-2 font-weight-bold mb-2 underline">{{
      this.title
    }}</span>
    <p
      class="body-1 font-weight-bold mb-0"
      v-for="(text, index) in texts"
      :key="index"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "TitleTexts",
  props: {
    title: {
      type: String,
    },
    texts: {
      type: Array,
    },
    row: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
